/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ step: NonNullable<unknown> }} Case_Step_LabelInputs */

const en_case_step_label = /** @type {(inputs: Case_Step_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.step === "creation") return /** @type {LocalizedString} */ (`Creation`);
	if (i?.step === "analysis") return /** @type {LocalizedString} */ (`Analysis`);
	if (i?.step === "negotiation") return /** @type {LocalizedString} */ (`Negotiation`);
	if (i?.step === "legal_analysis") return /** @type {LocalizedString} */ (`Legal Analysis`);
	if (i?.step === "legal_process") return /** @type {LocalizedString} */ (`Legal Process`);
	if (i?.step === "in_payment") return /** @type {LocalizedString} */ (`In Payment`);
	if (i?.step === "finalized") return /** @type {LocalizedString} */ (`Finalized`);
	if (i?.step === "deleted") return /** @type {LocalizedString} */ (`Deleted`);
	if (i?.step === "archived") return /** @type {LocalizedString} */ (`Archived`);
	return /** @type {LocalizedString} */ (`${i?.step}`)
	
};

const pt_br2_case_step_label = /** @type {(inputs: Case_Step_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.step === "creation") return /** @type {LocalizedString} */ (`Criação`);
	if (i?.step === "analysis") return /** @type {LocalizedString} */ (`Análise`);
	if (i?.step === "negotiation") return /** @type {LocalizedString} */ (`Negociação`);
	if (i?.step === "legal_analysis") return /** @type {LocalizedString} */ (`Análise Jurídica`);
	if (i?.step === "legal_process") return /** @type {LocalizedString} */ (`Processo judicial`);
	if (i?.step === "in_payment") return /** @type {LocalizedString} */ (`Em Pagamento`);
	if (i?.step === "finalized") return /** @type {LocalizedString} */ (`Finalizado`);
	if (i?.step === "deleted") return /** @type {LocalizedString} */ (`Excluído`);
	if (i?.step === "archived") return /** @type {LocalizedString} */ (`Arquivado`);
	return /** @type {LocalizedString} */ (`${i?.step}`)
	
};

/**
* | step | output |
* | --- | --- |
* | "creation" | "Creation" |
* | "analysis" | "Analysis" |
* | "negotiation" | "Negotiation" |
* | "legal_analysis" | "Legal Analysis" |
* | "legal_process" | "Legal Process" |
* | "in_payment" | "In Payment" |
* | "finalized" | "Finalized" |
* | "deleted" | "Deleted" |
* | "archived" | "Archived" |
* | * | "{step}" |
*
* @param {Case_Step_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_step_label = /** @type {((inputs: Case_Step_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Step_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_step_label(inputs)
	return pt_br2_case_step_label(inputs)
});